import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useGetOne, useRecordContext } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { Commission } from 'types/embedded/commission';
import { Order } from 'types/embedded/order';

type Props = {
  label?: string;
  source?: string;
  onClick: (record: Commission) => void;
};

export const OrdersReportListRuleField: React.FC<Props> = ({ onClick }) => {
  const record = useRecordContext<Order>();

  const { data: commission } = useGetOne<Commission>(
    Resources.Commissions,
    { id: record?.commission?.['@id'] || '' },
    { enabled: !!record },
  );

  if (!commission) {
    return EMPTY_FIELD;
  }
  const { fix, percent } = commission.rate || {};

  return (
    <Chip
      color="primary"
      label={`${commission?.currency?.alphaCode} ${fix ? '/ ' + fix : ''} ${percent ? '/ ' + percent + '%' : ''}`}
      onClick={() => onClick(commission)}
      sx={{ cursor: 'pointer' }}
    />
  );
};
